import React, { useEffect, useState } from "react"
import { CREDENTIAL_PROPS } from "./inteface"
import {
  Title,
  CredentialsWrapper,
  NameWrapper,
  Points,
  PointsWrapper,
  Point,
} from "../../GameBoardStyled"
import StakeCredential from "./StakeCredential"
import { calculateTimings } from "functions/calculations"
import { handleAnimationName } from "./helpers"

export const Credentials = ({
  stake,
  currency,
  precision,
  name,
  points,
  isGameActive,
  bankerLength,
  deal,
}: CREDENTIAL_PROPS): JSX.Element => {
  const [cardSum, setcardSum] = useState<(string | number)[]>([])
  const [animateNow, setanimateNow] = useState(Boolean)
  const [animName, setanimName] = useState(Number)

  useEffect(() => {
    if (deal) {
      if (points) {
        setanimateNow(false)
        if (points[1] === points[2]) {
          points.length = 2
        }
        const time =
          calculateTimings(name, points.length, bankerLength) * 1000 - 1000
        setanimName(handleAnimationName(time))
        setTimeout(
          () => {
            setanimateNow(true)
          },
          name === "banker" ? 1600 : 2000,
        )

        points[0] = ""
        setcardSum([])
        setTimeout(() => {
          setcardSum(points)
        }, 1000)
      }
    }
  }, [deal, points])

  return (
    <CredentialsWrapper
      isGameActive={isGameActive}
      className={`${name} CredentialsWrapper`}
    >
      <NameWrapper>
        <Title>{name}</Title>
        <PointsWrapper>
          <Points
            animateNow={animateNow}
            animName={animName}
            length={cardSum.length}
            isGameActive={deal}
          >
            {cardSum.map((point: string | number, i: number) => (
              <Point className='point' key={i}>
                {point}
              </Point>
            ))}
          </Points>
        </PointsWrapper>
      </NameWrapper>
      <StakeCredential stake={stake} precision={precision} currency={currency} />
    </CredentialsWrapper>
  )
}
